var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { KeyType } from '@interfaces/keys.interface';
import { setErrorMessage } from '@popup/multichain/actions/message.actions';
import { navigateTo, resetNav, } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { PeakDNotificationsUtils } from '@popup/steem/utils/notifications/peakd-notifications.utils';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { OperationButtonComponent } from 'src/common-ui/button/operation-button.component';
import { BackgroundType, CheckboxPanelComponent, } from 'src/common-ui/checkbox/checkbox-panel/checkbox-panel.component';
import { LoadingComponent } from 'src/common-ui/loading/loading.component';
import { SelectAccountSectionComponent } from 'src/common-ui/select-account-section/select-account-section.component';
const NotificationConfigPage = ({ activeAccount, setTitleContainerProperties, resetNav, navigateTo, setErrorMessage, }) => {
    const [isActive, setActive] = useState(false);
    const [userHasConfig, setUserHasConfig] = useState();
    const [ready, setReady] = useState(false);
    useEffect(() => {
        setTitleContainerProperties({
            title: 'html_popup_settings_notifications',
            isBackButtonEnabled: true,
        });
        if (activeAccount && activeAccount.name)
            initConfig(activeAccount.name);
    }, [activeAccount.name]);
    const initConfig = (activeAccountName) => __awaiter(void 0, void 0, void 0, function* () {
        const userConfig = yield PeakDNotificationsUtils.getAccountConfig(activeAccountName);
        setUserHasConfig(!!userConfig);
        setActive(!!userConfig);
        setReady(true);
    });
    const openAdvancedConfiguration = () => __awaiter(void 0, void 0, void 0, function* () {
        chrome.tabs.create({
            url: `peak-open-notifications-config.html`,
        });
    });
    const handleSubmitClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isActive === userHasConfig) {
            setErrorMessage('notification_settings_nothing_has_changed');
            return;
        }
        if (isActive) {
            yield PeakDNotificationsUtils.saveDefaultConfig(activeAccount);
        }
        else {
            setReady(false);
            yield PeakDNotificationsUtils.deleteAccountConfig(activeAccount);
        }
        resetNav();
        navigateTo(Screen.HOME_PAGE, true);
    });
    return (React.createElement(React.Fragment, null,
        ready && (React.createElement("div", { "data-testid": `${Screen.SETTINGS_NOTIFICATIONS_CONFIGURATION}-page`, className: `notifications-config-page` },
            React.createElement("div", { className: "caption" }, getMessage('html_popup_settings_notifications_caption')),
            React.createElement(SelectAccountSectionComponent, { fullSize: true, background: "white" }),
            React.createElement(CheckboxPanelComponent, { checked: isActive, onChange: setActive, backgroundType: BackgroundType.FILLED, title: "html_popup_settings_notifications_activated" }),
            React.createElement("div", { className: "link-to-advanced-settings", onClick: openAdvancedConfiguration }, getMessage('notification_settings_advanced_settings')),
            React.createElement("div", { className: "fill-space" }),
            React.createElement(OperationButtonComponent, { key: KeyType.POSTING, onClick: handleSubmitClick, label: 'popup_html_save' }))),
        !ready && React.createElement(LoadingComponent, null)));
};
const mapStateToProps = (state) => {
    return { activeAccount: state.steem.activeAccount };
};
const connector = connect(mapStateToProps, {
    setTitleContainerProperties,
    resetNav,
    navigateTo,
    setErrorMessage,
});
export const NotificationsConfigComponent = connector(NotificationConfigPage);
